import type { AvatarColor } from '@/components/ui/Avatar';

const PALETTE: AvatarColor[] = ['l1', 'l2', 'l3', 'accent'];

export function colorForPlayer(playerId: string): AvatarColor {
  let hash = 0;
  for (let i = 0; i < playerId.length; i++) {
    hash = (hash * 31 + playerId.charCodeAt(i)) >>> 0;
  }
  return PALETTE[hash % PALETTE.length];
}
